import { configureStore } from '@reduxjs/toolkit'
import subtitleSlice from './features/subtitle/subtitleSlice'

export default configureStore({
  reducer: {
    subtitles: subtitleSlice,
  },
})
